import { TagManagerWrapper } from '.';

export class WSGTMWrapper extends TagManagerWrapper {
  constructor(dataLayerName = 'wsgtmLayer', gtagFunctionName = 'wsgtmTag') {
    super(dataLayerName, gtagFunctionName, 'gtm');
  }

  public initWSGTM(containerId: string, serverUrl: string): void {
    if (!this.isValidId(containerId, /^GTM-/)) {
      throw new Error('Invalid GTM ID');
    }
    this.loadGTMScripts(containerId, serverUrl, this.dataLayerName);

    this.initConsent();
  }

  public override pushToDataLayer(eventName: string, eventParams: any): void {
    (window as any)[this.dataLayerName].push({
      event: eventName,
      ...eventParams,
    });
  }
}
